export enum SupplierTagEnum {
  Preferred = 'Preferred',
}
